import { useQueryClient } from '@tanstack/react-query';
import { useOverlayContext } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useLocaleKeys } from '~/i18n';
import { handleRequest } from '~/infra/utils';
import { useAppConfig, useStoreActions } from '~/store/store-context';
export const useDuplicateLegalTerms = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { showSuccessToast, showErrorToast } = useOverlayContext();
    const { generateUniqueId } = useAppConfig();
    const { t: commonTexts } = useLocaleKeys('common');
    const duplicateLegalTerms = async (legalTerm)=>{
        const newName = "".concat(legalTerm.name, " (copy)");
        const id = generateUniqueId('legalTerms');
        const contentString = JSON.stringify(legalTerm.richTextContent);
        const result = await handleRequest(api.business.createQuillLegalTerms({
            id,
            name: newName,
            content: contentString
        }));
        if (!result.success) {
            showErrorToast(commonTexts.toasts.anUnknownErrorHasOccurred());
            return;
        }
        showSuccessToast(commonTexts.toasts.documentDuplicatedSuccessfully());
        await queryClient.invalidateQueries({
            queryKey: [
                QueryKeys.LegalTerms
            ]
        });
    };
    return {
        duplicateLegalTerms
    };
};
